import { Injectable } from "@angular/core";
import { ResultsModalComponent } from "./results-modal.component";
import { ModalController } from "ionic-angular";
import { RegLookupRequest } from "./request.model";
import { FormControl, FormGroup } from "@angular/forms";
import { RegLookupControl } from "../reg-lookup-control.model";
import * as Q from "q";
import { RegLookupControlHelperService } from "./reg-lookup-control-helper.service";
import { Observable } from "rxjs/Observable";
import { combineLatest } from "rxjs/observable/combineLatest";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

@Injectable()
export class RegLookupControlController {

    constructor(
        protected appFacade: VasAppFacade,
        protected modalCtl: ModalController,
        protected helperService: RegLookupControlHelperService
    ) {

    }

    lookup(request: RegLookupRequest, formGroupToUpdate: FormGroup): Promise<any> {

        return [
            () => this.appFacade.loading.showLoading("REG_LOOKUP_IN_PROGRESS"),
            () => request.getResult(),
            result => this.showResultsModal(result, formGroupToUpdate),
            () => this.appFacade.loading.hideLoading()
        ].reduce<any>(Q.when, Q())
            .catch(error => {
                this.appFacade.loading.hideLoading();
                this.appFacade.alert.ok("An error occurred", error);
            });
    }

    isDisabled(formControl: FormControl): Observable<boolean> {
        return combineLatest(
            formControl.valueChanges,
            this.appFacade.network.isOnline()
        ).map(args => {
            const [value, isOnline] = args;
            return !value || !isOnline;
        });
    }

    getRegLookupRequest(value: string, definition: RegLookupControl): RegLookupRequest {
        return new RegLookupRequest(this.appFacade, definition, value);
    }

    showResultsModal(results, formGroupToUpdate: FormGroup): void {

        const modal = this.modalCtl.create(ResultsModalComponent, {
            results
        });

        modal.onDidDismiss(value => {

            if (value) {
                this.helperService.updateFormGroup(value, formGroupToUpdate);
            }
        });

        modal.present();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/reg-lookup-control.controller.ts